export const acceptedImageTypes = ['.jpg', '.jpeg', '.png', '.svg', '.gif', '.webp', '.avif', '.jfif', '.bmp'];
export const acceptedAudioTypes = ['.mp3', '.wav', '.ogg', '.m4a'];
export const acceptedVideoTypes = ['.mp4', '.webm', '.mov', '.mkv'];
export const acceptedVideoEditorTypes = ['.mp4', '.webm', '.mov'];

export const acceptedFiletypes = [...acceptedImageTypes, ...acceptedAudioTypes, ...acceptedVideoTypes];
//Make sure its the same as switch case in pageStore.ts ln 671

export const commonImageTypes = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp', '.ico', '.avif', '.heic', '.heif', '.tif', '.tiff'];

export const commonVideoTypes = ['.mp4', '.webm', '.mov', '.mkv', '.avi', '.ogv', '.m4v', '.mpg', '.mpeg', '.wmv', '.flv', '.3gp', '.3g2'];
